export enum LegalForm {
  AE = 'AE',
  EPE = 'EPE',
  IKE = 'IKE',
  OE = 'OE',
  EE = 'EE',
  ATOMIKI = 'ATOMIKI',
}

export enum AccountingType {
  SINGLE_ENTRY = 'SINGLE_ENTRY',
  DOUBLE_ENTRY = 'DOUBLE_ENTRY',
}

export enum VatRegime {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  EXEMPT = 'EXEMPT',
}

export enum DocumentStatus {
  NEW = 'NEW',
  REVIEWING = 'REVIEWING',
  REVIEWED = 'REVIEWED',
  POSTED = 'POSTED',
}

export enum DeadlineStatus {
  PENDING = 'PENDING',
  BLOCKED = 'BLOCKED',
  IN_PROGRESS = 'IN_PROGRESS',
  FILED = 'FILED',
  CONFIRMED = 'CONFIRMED',
  OVERDUE = 'OVERDUE',
  SKIPPED = 'SKIPPED',
}

export enum UploadSource {
  PORTAL = 'PORTAL',
  EMAIL = 'EMAIL',
  DASHBOARD = 'DASHBOARD',
}

export enum InviteChannel {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export enum NotificationType {
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  DEADLINE_APPROACHING = 'DEADLINE_APPROACHING',
  DEADLINE_OVERDUE = 'DEADLINE_OVERDUE',
  DEADLINE_EXTENDED = 'DEADLINE_EXTENDED',
  REQUEST_PENDING = 'REQUEST_PENDING',
  MYDATA_ALERT = 'MYDATA_ALERT',
  AI_EXTRACTION_COMPLETE = 'AI_EXTRACTION_COMPLETE',
  SYSTEM = 'SYSTEM',
}

export enum NotificationChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  PUSH = 'PUSH',
  IN_APP = 'IN_APP',
}

export enum NotificationStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  READ = 'READ',
  FAILED = 'FAILED',
}

export enum RecipientType {
  USER = 'USER',
  CONTACT = 'CONTACT',
}

export enum ObligationFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  ANNUAL = 'ANNUAL',
  CUSTOM = 'CUSTOM',
}

export enum RequestStatus {
  PENDING = 'PENDING',
  SEEN = 'SEEN',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum DocumentType {
  TIMOLOGIO_POLISIS = 'TIMOLOGIO_POLISIS',
  TIMOLOGIO_PAROHIS_YPIRESION = 'TIMOLOGIO_PAROHIS_YPIRESION',
  APODEIXI = 'APODEIXI',
  PISTOTIKO = 'PISTOTIKO',
  LOGARIASMOS_DEKO = 'LOGARIASMOS_DEKO',
  APODEIXI_ENOIKIOU = 'APODEIXI_ENOIKIOU',
  OTHER = 'OTHER',
}

export enum ExpenseCategory {
  TILEKOINONIES = 'TILEKOINONIES',
  ENOIKIA = 'ENOIKIA',
  YLIKA = 'YLIKA',
  METAFORIKA = 'METAFORIKA',
  KAFETERIA_ESTIASI = 'KAFETERIA_ESTIASI',
  LOGISTIKES_YPIRESIES = 'LOGISTIKES_YPIRESIES',
  ENERGIA = 'ENERGIA',
  YDREFSI = 'YDREFSI',
  MISTHODOSIA = 'MISTHODOSIA',
  ASFALISTIKES_EISFORES = 'ASFALISTIKES_EISFORES',
  OTHER = 'OTHER',
}

export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
}

export enum TaskPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export enum TaskSource {
  MANUAL = 'MANUAL',
  DEADLINE = 'DEADLINE',
  MYDATA = 'MYDATA',
  RECURRING = 'RECURRING',
  REQUEST = 'REQUEST',
}

export enum MessageDirection {
  OFFICE_TO_CLIENT = 'OFFICE_TO_CLIENT',
  CLIENT_TO_OFFICE = 'CLIENT_TO_OFFICE',
}
